/**
 * Get the gender french shorthand
 *
 * @param {string} gender The gender of the patient Eg: "male"
 */
const getGenderTag = (gender: string) => {
  if (gender === 'male') return 'H'
  else if (gender === 'female') return 'F'
  return gender
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('gender-tag', {
    mounted(el, binding) {
      const { value } = binding
      if (!value) {
        console.error('Please provide a gender for the gender tag')
        el.innerHTML = ''
        return
      }
      el.innerHTML = getGenderTag(value)
    },
  })
})
